namespace $.$$ {
	export class $shm_ba_mention_stats_task extends $.$shm_ba_mention_stats_task {
		filter_text( value: string ) {
			return String( value ).replaceAll( '\\', '\\\\' ).replaceAll( '"', '\\"' )
		}

		task() {
			const id = this.task_id().trim()
			if( !id ) return null
			return this.$.$shm_ba_pb.records_page_realtime_live(
				`mention_stats_tasks\nid = "${ this.filter_text( id ) }"\n\n1\n1`,
				`mention_stats_tasks/id:${ id }`,
				record => record.id === id,
			)[0] ?? null
		}

		task_title() { return String( this.task()?.title || '' ) }

		task_pages() {
			return this.task_mode() === 'view'
				? [ this.Report_page(), this.Filters_page() ]
				: [ this.Edit_page(), this.Items_page() ]
		}

		task_mode_key() { return `hitalama_mentionstat_task_mode:${ this.task_id() }` }
		task_mode() {
			const arg = String( this.$.$mol_state_arg.value( 'mention_stats_mode' ) || '' )
			if( arg === 'view' || arg === 'edit' ) return arg === 'view' && !this.mode_view_enabled() ? 'edit' : arg
			const stored = String( this.$.$mol_state_local.value( this.task_mode_key() ) || '' )
			const mode = stored === 'view' && this.mode_view_enabled() ? 'view' : 'edit'
			this.$.$mol_state_arg.value( 'mention_stats_mode', mode )
			return mode
		}

		@ $mol_action
		mode_set( mode: 'edit' | 'view' ) {
			if( mode === 'view' && !this.mode_view_enabled() ) return
			this.$.$mol_state_local.value( this.task_mode_key(), mode )
			this.$.$mol_state_arg.value( 'mention_stats_mode', mode )
		}

		mode_edit( next?: Event ) { if( next !== undefined ) this.mode_set( 'edit' ); return next ?? null }
		mode_view( next?: Event ) { if( next !== undefined ) this.mode_set( 'view' ); return next ?? null }
		mode_view_enabled() { return Boolean( this.task_result_uri() ) }
		mode_edit_color() { return this.task_mode() === 'edit' ? 'var(--mol_theme_current)' : '' }
		mode_view_color() { return this.task_mode() === 'view' ? 'var(--mol_theme_current)' : '' }

		@ $mol_mem_key
		title_draft( id: string, next?: string ) { return next ?? this.task_title() }
		task_title_draft( next?: string ) { return this.title_draft( this.task_id(), next ) }

		@ $mol_action
		task_title_save( next?: Event ) {
			if( next === undefined ) return null
			const title = this.task_title_draft().trim() || 'Задача'
			if( title !== this.task_title() ) this.$.$shm_ba_pb.update_record( 'mention_stats_tasks', this.task_id(), { title } )
			this.task_title_draft( title )
			return next
		}

		@ $mol_action
		task_delete( next?: Event ) {
			if( next === undefined ) return null

			const id = this.task_id().trim()
			this.Settings().showed( false )
			if( !id ) return next

			this.$.$mol_state_local.value( `hitalama_mentionstat_task_mode:${ id }`, null )
			this.$.$mol_state_arg.value( 'mention_stats_task', null )
			this.$.$mol_state_arg.value( 'mention_stats_mode', null )
			const trigger = `mention_stats_tasks/user:${ this.$.$shm_ba_pb.user_id() }:list`
			this.$.$shm_ba_pb.realtime_live_remove( trigger, id )
			this.$.$mol_wire_async( this ).task_delete_later( id, trigger ).catch( error => console.error( error ) )

			return next
		}

		async task_delete_later( id: string, trigger: string ) {
			try {
				const response = await this.$.$mol_dom_context.fetch(
					`${ this.$.$shm_ba_pb.url() }/api/collections/mention_stats_tasks/records/${ encodeURIComponent( id ) }`,
					{ method: 'DELETE', headers: this.$.$shm_ba_pb.json_headers() },
				)
				if( !response.ok ) throw new Error( await response.text() || response.statusText )
			} catch( error ) {
				this.$.$shm_ba_pb.realtime_live_reload( trigger )
				throw error
			}
		}

		items() {
			const id = this.task_id().trim()
			if( !id ) return [] as readonly $shm_ba_pb_file_record[]
			const result: $shm_ba_pb_file_record[] = []
			for( let page = 1; page <= 1000; ++page ) {
				const chunk = this.$.$shm_ba_pb.records_page_realtime(
					`mention_stats_items\ntask = "${ this.filter_text( id ) }"\nsort\n${ page }\n500`,
				)
				result.push( ...chunk )
				if( chunk.length < 500 ) break
			}
			return result
		}

		item( id: string ) { return this.items().find( item => item.id === id ) }
		item_ids() { return this.items().map( item => item.id ) }
		item_query( id: string ) { return String( this.item( id )?.query || '' ) }
		item_excluded( id: string ) { return String( this.item( id )?.excluded_words || '' ) }
		item_period( id: string ) {
			const item = this.item( id )
			return [ item?.date_from, item?.date_to ].filter( Boolean )
				.map( date => this.$.$shm_date.text( String( date ).slice( 0, 10 ) ) ).join( ' – ' )
		}
		item_country( id: string ) { return String( this.item( id )?.country || '' ) }
		item_language( id: string ) { return String( this.item( id )?.language || '' ) }
		item_social( id: string ) { return String( this.item( id )?.social_media || '' ) }
		item_mass( id: string ) { return String( this.item( id )?.mass_media || '' ) }
		item_type( id: string ) { return String( this.item( id )?.search_type || '' ) }
		item_tags( id: string ) { return String( this.item( id )?.tags || '' ) }
		item_category( id: string ) { return String( this.item( id )?.category || '' ) }

		@ $mol_mem
		editing_id( next?: string ) { return next ?? '' }

		@ $mol_mem
		saving( next?: boolean ) { return next ?? false }

		@ $mol_mem
		form_error( next?: string ) { return next ?? '' }

		form_submit_title() { return this.saving() ? 'Сохранение...' : this.editing_id() ? 'Сохранить' : 'Добавить' }
		form_social_existing_title() { return String( this.item( this.editing_id() )?.social_media || '' ) }
		form_mass_existing_title() { return String( this.item( this.editing_id() )?.mass_media || '' ) }

		@ $mol_action
		form_submit( next?: Event ) {
			if( next === undefined || this.saving() ) return next ?? null
			if( !this.form_query().trim() ) {
				this.form_error( 'Заполните поле «Поисковой запрос»' )
				this.Form().Query().focused( true )
				return next
			}
			this.saving( true )
			this.form_error( '' )
			$mol_wire_async( this ).item_save().catch( error => {
				this.form_error( error instanceof Error ? error.message : String( error ) )
			} ).finally( ()=> this.saving( false ) )
			return next
		}

		async item_save() {
			const query = this.form_query().trim()
			if( !query ) throw new Error( 'Заполните поле «Поисковой запрос»' )
			const form = new FormData()
			form.set( 'task', this.task_id() )
			form.set( 'query', query )
			form.set( 'excluded_words', this.form_excluded_words().trim() )
			form.set( 'date_from', this.form_date_from() )
			form.set( 'date_to', this.form_date_to() )
			form.set( 'country', this.form_country().trim() )
			form.set( 'language', this.form_language().trim() )
			form.set( 'search_type', this.form_search_type() )
			form.set( 'tags', this.form_tags().trim() )
			form.set( 'category', this.form_category().trim() )
			form.set( 'status', 'uploaded' )
			form.set( 'sort', String( Date.now() ) )
			const social = this.form_social_files()[0]
			const mass = this.form_mass_files()[0]
			if( social ) form.set( 'social_media', social )
			if( mass ) form.set( 'mass_media', mass )

			const editing = this.editing_id()
			if( editing ) await this.$.$shm_ba_pb.update_form_record_async( 'mention_stats_items', editing, form )
			else await this.$.$shm_ba_pb.create_form_record_async( 'mention_stats_items', form )

			this.editing_id( '' )
			this.form_query( '' )
			this.form_excluded_words( '' )
			this.form_social_files( [] )
			this.form_mass_files( [] )
		}

		@ $mol_action
		form_reset( next?: Event ) {
			if( next === undefined ) return null
			this.editing_id( '' )
			this.form_query( '' )
			this.form_excluded_words( '' )
			this.form_date_from( '' )
			this.form_date_to( '' )
			this.form_country( '' )
			this.form_language( '' )
			this.form_search_type( '' )
			this.form_tags( '' )
			this.form_category( '' )
			this.form_social_files( [] )
			this.form_mass_files( [] )
			this.form_error( '' )
			return next
		}

		@ $mol_action
		item_edit( id: string, next?: Event ) {
			if( next === undefined ) return null
			const item = this.item( id )
			if( !item ) return next
			this.editing_id( id )
			this.form_query( String( item.query || '' ) )
			this.form_excluded_words( String( item.excluded_words || '' ) )
			this.form_date_from( String( item.date_from || '' ) )
			this.form_date_to( String( item.date_to || '' ) )
			this.form_country( String( item.country || '' ) )
			this.form_language( String( item.language || '' ) )
			this.form_search_type( String( item.search_type || '' ) )
			this.form_tags( String( item.tags || '' ) )
			this.form_category( String( item.category || '' ) )
			this.form_social_files( [] )
			this.form_mass_files( [] )
			return next
		}

		@ $mol_action
		item_delete( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.$.$shm_ba_pb.delete_record( 'mention_stats_items', id )
			if( this.editing_id() === id ) this.editing_id( '' )
			return next
		}

		@ $mol_mem
		merge_error( next?: string ) { return next ?? '' }

		@ $mol_mem
		merging( next?: boolean ) { return next ?? false }

		merge_title() { return this.merging() ? 'Формирование...' : 'Сформировать таблицу' }
		merge_enabled() { return Boolean( this.items().length && !this.merging() ) }
		status_text() {
			const form_error = this.form_error()
			if( form_error ) throw new Error( form_error )
			if( this.merge_error() ) return this.merge_error()
			if( this.task()?.status === 'done' ) return `Готово: ${ Number( this.task()?.row_count || 0 ).toLocaleString( 'ru-RU' ) } строк`
			return ''
		}

		merge_url() {
			const override = $mol_state_arg.value( 'mention_stats_export' )
			if( override ) return override
			const location = this.$.$mol_dom_context.location
			if( [ 'localhost', '127.0.0.1' ].includes( location.hostname ) ) return 'http://127.0.0.1:9081/mention_stats_duckdb'
			return `${ location.protocol }//duckdb.${ location.hostname.replace( /^dashboard\./, '' ) }/mention_stats_duckdb`
		}

		@ $mol_action
		merge_start( next?: Event ) {
			if( next === undefined || !this.merge_enabled() ) return next ?? null
			this.merging( true )
			this.merge_error( '' )
			$mol_wire_async( this ).merge_items().then( ()=> this.mode_set( 'view' ) )
				.catch( error => this.merge_error( error instanceof Error ? error.message : String( error ) ) )
				.finally( ()=> this.merging( false ) )
			return next
		}

		async merge_items() {
			const query = new URLSearchParams({ task: this.task_id(), pb_url: this.$.$shm_ba_pb.url() })
			const response = await this.$.$mol_dom_context.fetch( `${ this.merge_url() }?${ query }`, {
				method: 'POST',
				headers: { Authorization: this.$.$shm_ba_pb.auth_header_token( this.$.$shm_ba_pb.auth_user_token() ) },
			} )
			const text = await response.text()
			const data = text ? JSON.parse( text ) : null
			if( !response.ok ) throw new Error( String( data?.message || text || response.statusText ) )
			this.$.$shm_ba_pb.realtime_live_reload( `mention_stats_tasks/id:${ this.task_id() }` )
			this.$.$shm_ba_pb.realtime_version( 'mention_stats_items/*', Date.now() )
			return data
		}

		task_result_uri() {
			const record = this.task()
			if( !record ) return ''
			const file = this.$.$shm_ba_pb.record_files( record, 'result_file' )[0]
			return file ? this.$.$shm_ba_pb.file_uri( record, 'mention_stats_tasks', file ) : ''
		}

		task_result_file() {
			const record = this.task()
			return record ? this.$.$shm_ba_pb.record_files( record, 'result_file' )[0] || '' : ''
		}

		@ $mol_mem
		task_file() {
			const file = new this.$.$shm_wordstat_task_file()
			file.task_id = ()=> `mentionstat_${ this.task_id() }`
			file.version = ()=> this.task_result_file()
			file.uri = ()=> this.task_result_uri()
			file.token = ()=> this.$.$shm_ba_pb.auth_token()
			return file
		}

		option_values( field: string ) {
			return [ ... new Set( this.items().map( item => String( item[ field ] || '' ) ) ) ].toSorted()
		}

		query_values() { return this.option_values( 'query' ) }
		scope_values() {
			const values: string[] = []
			if( this.items().some( item => Boolean( item.social_media ) ) ) values.push( 'Соцмедиа' )
			if( this.items().some( item => Boolean( item.mass_media ) ) ) values.push( 'СМИ' )
			return values
		}
		country_values() { return this.option_values( 'country' ) }
		language_values() { return this.option_values( 'language' ) }
		type_values() { return this.option_values( 'search_type' ) }
		category_values() { return this.option_values( 'category' ) }

		@ $mol_mem_key
		filter_map( kind: string, next?: Record< string, boolean > ) {
			if( next ) return next
			return Object.fromEntries( this.filter_values( kind ).map( value => [ value, true ] ) )
		}

		filter_values( kind: string ) {
			return ({ query: this.query_values(), scope: this.scope_values(), country: this.country_values(), language: this.language_values(), type: this.type_values(), category: this.category_values() } as Record< string, readonly string[] >)[ kind ] ?? []
		}

		filter_checked( kind: string, value: string, next?: boolean ) {
			const map = this.filter_map( kind )
			if( next === undefined ) return Boolean( map[ value ] )
			this.filter_map( kind, { ... map, [ value ]: next } )
			return next
		}

		filter_all( kind: string, next?: boolean ) {
			const values = this.filter_values( kind )
			if( next === undefined ) return Boolean( values.length && values.every( value => this.filter_map( kind )[ value ] ) )
			this.filter_map( kind, Object.fromEntries( values.map( value => [ value, next ] ) ) )
			return next
		}

		filter_only( kind: string, value: string, next?: Event ) {
			if( next === undefined ) return null
			this.filter_map( kind, Object.fromEntries(
				this.filter_values( kind ).map( item => [ item, item === value ] ),
			) )
			return next
		}

		query_checked( value: string, next?: boolean ) { return this.filter_checked( 'query', value, next ) }
		scope_checked( value: string, next?: boolean ) { return this.filter_checked( 'scope', value, next ) }
		country_checked( value: string, next?: boolean ) { return this.filter_checked( 'country', value, next ) }
		language_checked( value: string, next?: boolean ) { return this.filter_checked( 'language', value, next ) }
		type_checked( value: string, next?: boolean ) { return this.filter_checked( 'type', value, next ) }
		category_checked( value: string, next?: boolean ) { return this.filter_checked( 'category', value, next ) }
		query_only( value: string, next?: Event ) { return this.filter_only( 'query', value, next ) }
		scope_only( value: string, next?: Event ) { return this.filter_only( 'scope', value, next ) }
		country_only( value: string, next?: Event ) { return this.filter_only( 'country', value, next ) }
		language_only( value: string, next?: Event ) { return this.filter_only( 'language', value, next ) }
		type_only( value: string, next?: Event ) { return this.filter_only( 'type', value, next ) }
		category_only( value: string, next?: Event ) { return this.filter_only( 'category', value, next ) }
		query_all( next?: boolean ) { return this.filter_all( 'query', next ) }
		scope_all( next?: boolean ) { return this.filter_all( 'scope', next ) }
		country_all( next?: boolean ) { return this.filter_all( 'country', next ) }
		language_all( next?: boolean ) { return this.filter_all( 'language', next ) }
		type_all( next?: boolean ) { return this.filter_all( 'type', next ) }
		category_all( next?: boolean ) { return this.filter_all( 'category', next ) }

		selected( kind: string ) {
			const map = this.filter_map( kind )
			return this.filter_values( kind ).filter( value => map[ value ] )
		}

		period_default() {
			const dates = this.items().flatMap( item => [ String( item.date_from || '' ), String( item.date_to || '' ) ] ).filter( Boolean ).toSorted()
			return { from: dates[0] || '0001-01-01', to: dates[ dates.length - 1 ] || '2999-12-31' }
		}

		@ $mol_mem_key
		filter_date( edge: string, next?: string ) {
			return next ?? this.period_default()[ edge === 'from' ? 'from' : 'to' ]
		}

		filter_date_from( next?: string ) { return this.filter_date( 'from', next ) }
		filter_date_to( next?: string ) { return this.filter_date( 'to', next ) }

		@ $mol_action
		filter_reset( next?: Event ) {
			if( next === undefined ) return null
			for( const kind of [ 'query', 'scope', 'country', 'language', 'type', 'category' ] ) this.filter_all( kind, true )
			this.filter_date_from( this.period_default().from )
			this.filter_date_to( this.period_default().to )
			return next
		}

		@ $mol_mem
		data() {
			const data = new this.$.$shm_mentionstat_data()
			data.app_id = ()=> `mentionstat_${ this.task_id() }`
			data.file_name = ()=> this.task_file().opfs_name()
			data.file_source = ()=> this.task_file()
			data.queries = ()=> this.selected( 'query' )
			data.scopes = ()=> this.selected( 'scope' )
			data.countries = ()=> this.selected( 'country' )
			data.languages = ()=> this.selected( 'language' )
			data.types = ()=> this.selected( 'type' )
			data.categories = ()=> this.selected( 'category' )
			data.group = ()=> this.chart_group()
			data.date_from = ()=> this.filter_date_from() || '0001-01-01'
			data.date_to = ()=> this.filter_date_to() || '2999-12-31'
			return data
		}

		query_table() { return this.data().query_table() }
		chart_rows() { return this.data().chart_timeseries() }
		result_rows() {
			return this.query_table().rows.length ? [ this.Chart(), this.Table() ] : [ this.Empty() ]
		}

		report_tools() {
			return this.query_table().rows.length ? [ this.Csv_download() ] : []
		}

		csv_cell( value: unknown ) {
			const text = String( value ?? '' )
			return /[";\n\r]/.test( text ) ? `"${ text.replaceAll( '"', '""' ) }"` : text
		}

		csv_text() {
			const table = this.query_table()
			return [ table.head, ... table.rows ]
				.map( row => row.map( cell => this.csv_cell( cell ) ).join( ';' ) )
				.join( '\r\n' )
		}

		csv_blob() {
			return new Blob([ '\uFEFF', this.csv_text() ], { type: 'text/csv;charset=utf-8' })
		}

		csv_date_title( date: string ) {
			const match = String( date ).match( /^(\d{4})-(\d{2})-(\d{2})/ )
			return match ? `${ match[3] }.${ match[2] }.${ match[1] }` : date
		}

		csv_file_name() {
			const title = ( this.task_title().trim() || 'Статистика упоминаний' )
				.replace( /[<>:"/\\|?*\u0000-\u001F]/g, '_' )
			const period = `${ this.csv_date_title( this.filter_date_from() ) }-${ this.csv_date_title( this.filter_date_to() ) }`
			return `${ title }_${ period }.csv`
		}
	}
}
